import { createRenderer } from "./createRenderer";

export const renderer = createRenderer();
